<template>
  <div
    :style="{
      width: qrwidth + 'px',
      height: qrheight + 'px',
      filter: blur ? 'blur(2px)' : ''
    }"
  >
    <img :src="QRImgUrl" />
  </div>
</template>

<script>
import QRCode from "qrcode";
export default {
  props: {
    qrwidth: {
      type: Number,
      default: 259
    },
    qrheight: {
      type: Number,
      default: 259
    },
    QRlink: {
      type: String,
      default: ""
    },
    blur: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      QRImgUrl: ""
      //   QRlink: "www.xxx.com"
    };
  },
  // props: ["QRlink"],
  created() {
    this.getQRcode();
  },
  methods: {
    getQRcode() {
      // console.log(this.qrwidth);
      let opts = {
        errorCorrectionLevel: "L", //容错级别
        type: "image/png", //生成的二维码类型
        quality: 0.3, //二维码质量
        margin: 0, //二维码留白边距
        width: this.qrwidth, //宽
        height: this.qrheight, //高
        text: this.QRlink, //二维码内容
        color: {
          dark: "#000", //前景色
          light: "#fff" //背景色
        }
      };
      //this.QRlink 生成的二维码地址url
      // console.log(this.QRlink);
      QRCode.toDataURL(this.QRlink, opts, (err, url) => {
        if (err) throw err;
        //将生成的二维码路径复制给data的QRImgUrl
        this.QRImgUrl = url;
      });
    }
  },
  watch: {
    // qrwidth: function(newVal, oldVal) {
    //   console.log(newVal, oldVal);
    // },
    QRlink: function(val) {
      // console.log(val);
      this.getQRcode();
    }
  }
};
</script>
<style scoped lang="scss"></style>



// WEBPACK FOOTER //
// src/components/QRcode.vue